export default {
  common: {
    menu: 'Menu',
    error: 'Chyba',
    no: 'Nie',
    search: 'Hľadať',
    selected: 'Vybrané',
    yes: 'Áno',
  },
  actions: {
    clear: 'Vymazať',
  },
};
